<template>
<div :class="(config.layout === 'desktop') ? 'with-breadcrumb' : 'without-breadcrumb'">

    <page-loading v-if="!data_loaded" />

    <div v-else class="container-fluid">
		<div class="row client" :class="{ 'inactive' : client.status != 1 }">
			<div class="col-12 col-md-6">
				<div class="card" id="profile" data-test="clientProfile">
	                <div class="profile-header d-flex align-items-end rounded-top text-white text-3xl">

	                    <span class="profile-name flex-grow-1 font-weight-bold mr-2 mb-2 leading-none" data-test="clientName">
	                    	{{ client.name }}
	                    </span>

	                    <div v-if="client.can.update" class="drop-down drop-down-show dropleft mr-35" style="z-index:10">
	                        <a href="#" role="button" id="clientDropDown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-test="contextMenu">
	                            <i class="far fa-ellipsis-h text-xl text-white"></i>
	                        </a>
							<div class="dropdown-menu dropdown-menu-right py-0" aria-labelledby="dropdownMenuLink">
								<router-link :to="{ name: 'clients.edit', params: { id: client.id } }" class="dropdown-item" data-test="editClientLink">Edit Client</router-link>
							</div>
						</div>

						<div class="profile-image rounded-top" :style="'background-image:url(' + client.photo_url + ');'"></div>
					</div>

					<div class="px-35 pt-2 pb-35">
	                	<div class="mb-3" :class="$root.$mq === 'xs' || $root.$mq === 'sm' ? '' : 'd-flex'">
	                        <div class="profile-avatar" style="position: relative;">
	                            <div class="rounded-circle circle-cropped avatar-xl mr-3 bg-white">
	                                <img class="img-fluid" :src="client.logo_url" alt="Logo" >
	                            </div>                    
	                        </div>

	                        <div class="flex-grow-1">
	                        	<div v-if="client.formatted_address" class="mb-3" v-html="client.formatted_address" />

                                <div v-if="client.contact_display_name" class="font-weight-bold">
                                    <i class="fal fa-address-book fa-fw text-gray-500 mr-1" v-tooltip.bottom="'Contact name'"></i>
                                    {{ client.contact_display_name }}</a>
                                </div> 
								<div v-if="client.email">
									<i class="fal fa-envelope fa-fw text-gray-500 mr-1"></i>
									<a :href="'mailto:' + client.email">{{ client.email }}</a>
								</div>
								<div v-if="client.phone">
									<i class="fal fa-phone fa-fw text-gray-500 mr-1"></i>
									{{ client.phone }}
								</div>
								<div v-if="client.fax">
									<i class="fal fa-fax fa-fw text-gray-500 mr-1"></i> {{ client.fax }}
								</div>
	                        </div>
	                	</div>
	                </div>
				</div>

				<div class="card" id="users">
					<div class="card-header">Users</div>
					<ul class="list-group list-group-flush">
						<li v-for="user in client.users" class="list-group-item d-flex">
							<div class="rounded-circle avatar-md circle-cropped mr-2">
								<img class="img-fluid" :src="user.photo_url">
							</div>
							<div class="media-body">
								<router-link :to="{ name: 'users.show', params: { id: user.id } }" class="font-weight-bold">{{ user.display_name }}</router-link><br>
								<span v-for="role in user.roles" class="badge bg-blue-100 text-blue-700 mr-1">{{ role.name }}</span>
							</div>
						</li>
					</ul>						
				</div>

				<div class="card goals" id="goals">
					<div class="card-header">Active Goals</div>
					<div v-if="!clientGoals.length" class="text-center text-lg text-gray-500 p-35">
						No goals found.
					</div>
					<div v-else class="mt-3">
						<goal-item-small 
							v-for="(goal, key) in clientGoals.filter(goal => goal.status == 1)"
							:goal="goal"
							:key="key"
							class="px-35"
						/>
					</div>
					<div class="card-footer">
						Add, edit, or view all  goals in the <router-link :to="{ name: 'goals.index' }">goal manager</router-link>.
					</div>
				</div>				
			</div>

			<div class="col-12 col-md-6 mb-3 pb-5 pb-md-0">
				<div class="card" id="services" data-test="clientLines">					
					<div class="card-header">Service Line Activity</div>
					<ul class="list-group list-group-flush">
						<li v-for="service_line_checkins in client.service_lines_checkins" class="list-group-item">
							
							<div class="text-gray-500">
								<span class="font-weight-bold text-gray-700">{{ service_line_checkins.label }}</span> Check-ins
							</div>

							<div class="d-flex align-items-center">
								<div class="text-5xl font-weight-bold mr-2 leading-tight text-gray-900">
									{{ service_line_checkins.recent }}
								</div>
								<div class="text-gray-500 leading-none">
									<template v-if="service_line_checkins.recent > service_line_checkins.trailing">
										<span class="text-positive"><i class="fas fa-caret-up"></i> {{ Math.abs(service_line_checkins.recent - service_line_checkins.trailing) }} ({{ service_line_checkins.change }}%)</span><br>
									</template>
									<template v-else-if="service_line_checkins.recent < service_line_checkins.trailing">
										<span class="text-negative"><i class="fas fa-caret-down"></i> {{ Math.abs(service_line_checkins.recent - service_line_checkins.trailing) }} ({{ service_line_checkins.change }}%)</span><br>
									</template>
									<template v-else>
										<span class="text-neutral"><i class="fas fa-caret-up"></i> {{ Math.abs(service_line_checkins.recent - service_line_checkins.trailing) }} ({{ service_line_checkins.change }}%)</span><br>							
									</template>								
									<span class="text-sm">vs prior week</span>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>

	<section id="bottom-menu" class="d-md-none navbar fixed-bottom bg-white text-center text-sm border-top pt-1 pb-0" style="z-index:1010">
        <a class="btn btn-ghost btn-sm text-gray-700 text-sm" href="#" v-scroll-to="'#profile'">
            <i class="text-secondary fal fa-hospital"></i><br>
            Profile
        </a>
        <a class="btn btn-ghost btn-sm text-gray-700 text-sm" href="#" v-scroll-to="'#users'">
            <i class="text-secondary fal fa-users"></i><br>
            Users
        </a>
        <a class="btn btn-ghost btn-sm text-gray-700 text-sm" href="#" v-scroll-to="'#goals'">
            <i class="text-secondary fal fa-trophy-alt"></i><br>
            Goals
        </a>
        <a class="btn btn-ghost btn-sm text-gray-700 text-sm" href="#" v-scroll-to="'#services'">
            <i class="text-secondary fal fa-puzzle-piece"></i><br>
            Services
        </a>
    </section>
</div>
</template>

<script>
	import { mapState } from 'vuex'
	import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import GoalItemSmall from '../../components/GoalItemSmall';

	export default {
		mixins: [BreadcrumbsManager],

		components: {
			GoalItemSmall
		},

        data() {
            return {
                client: null,

                clientGoals: [],
                clientGoalsLoaded: false,

                data_loaded: false,
            }
        },

        created() {
        	this.fetchClient();
        	this.fetchClientGoals();
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Clients', to: { name: 'clients.index'} },
                { text: '[Client Name]', to: { name: 'clients.show'} },
            ]);  
        },

        methods: {
        	fetchClient() {
        		axios.get('/api/admin/clients/' + this.$route.params.id).then(({data}) => {
                    this.client = data;
                    this.data_loaded = true;

                    this.replaceBreadcrumb({
                        find: '[Client Name]',
                        replace: { text: this.client.name }
                    });                     
	        	});
        	},

        	fetchClientGoals() {
        		axios.get('/api/goals/client/' + this.$route.params.id).then(({data}) => {
        			this.clientGoals = data;
        			this.clientGoalsLoaded = true;
        		});
        	},        	
        },

        computed: mapState(['config', 'perms'])
    }
</script>

<style scoped>
    .with-breadcrumb {
        margin-top:70px;
    }

    .without-breadcrumb {
        margin-top:20px;
    }
</style>